// src/components/KPICards.js
// Shows total sessions, total messages, avg messages/session, distinct companies, distinct users
import React from 'react';

const KPICards = ({ totalSessions, totalMessages, avgMessages, totalFirmen, totalUsers }) => (
  <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
    <div className="bg-white rounded-lg shadow p-6 text-center">
      <div className="text-gray-500">Gesamtsitzungen</div>
      <div className="text-3xl font-bold">{totalSessions}</div>
    </div>
    <div className="bg-white rounded-lg shadow p-6 text-center">
      <div className="text-gray-500">Gesamtnachrichten</div>
      <div className="text-3xl font-bold">{totalMessages}</div>
    </div>
    <div className="bg-white rounded-lg shadow p-6 text-center">
      <div className="text-gray-500">Ø Nachr./Sitzung</div>
      <div className="text-3xl font-bold">{avgMessages}</div>
    </div>
    <div className="bg-white rounded-lg shadow p-6 text-center">
      <div className="text-gray-500">Firmen</div>
      <div className="text-3xl font-bold">{totalFirmen}</div>
    </div>
    <div className="bg-white rounded-lg shadow p-6 text-center">
      <div className="text-gray-500">Benutzern</div>
      <div className="text-3xl font-bold">{totalUsers}</div>
    </div>
  </div>
);

export default KPICards;
